import { all, takeEvery } from 'redux-saga/effects'

import { actions } from '../constants'

import fetchFields from './fetchFields'
import submit from './submit'

export default function* () {
  yield all([takeEvery(actions.FETCH, fetchFields), takeEvery(actions.SUBMIT, submit)])
}
